'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _PageItem = require('react-bootstrap/lib/PageItem');

var _PageItem2 = _interopRequireDefault(_PageItem);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _PageItem2.default;


//////////////////
// WEBPACK FOOTER
// ./~/@sketchpixy/rubix/lib/PageItem.js
// module id = 654
// module chunks = 0